module.exports = __webpack_public_path__ + "img/terroir-liquify-1.77969796.jpg";